//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data: function data() {
		return {
			selectedTab: 1,
			tabs: [],
			hideLease: 1
		};
	},

	props: {
		resident: {
			required: true,
			type: Object
		},
		isBlacklisted: {
			required: true,
			type: Boolean,
			default: false
		},
		isUserExist: {
			required: true,
			type: Boolean,
			default: false
		}
	},
	mounted: function mounted() {
		var _this = this;

		this.tabs = this.$children;

		Event.$on('reset-tabs', function () {
			_this.tabs.map(function (tab) {
				return tab.isActive = false;
			});
			_this.tabs[1].isActive = true;
		});
		Event.$on('reset-lease-tab', function () {
			_this.tabs.map(function (tab) {
				return tab.isActive = false;
			});
			_this.tabs[3].isActive = true;
		});
		Event.$on('reset-resident-tabs', function () {
			_this.tabs.map(function (tab) {
				return tab.isActive = false;
			});
			_this.tabs[1].isActive = true;
		});
		// select the first tab to fire event
		// excludes the resident-actions component
		// that is loaded as first child
		this.selectTab(this.tabs[1]); //@TODO: I think also
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('reset-resident-tabs');
		Event.$off('reset-lease-tab');
		Event.$off('reset-tabs');
	},

	// created() {
	// 	this.resident.lease = this.getActiveLease(this.resident.leases);
	// },
	methods: {
		getActiveLease: function getActiveLease(leases) {
			if (leases.length === 0) return null;

			// look for first active, or else first lease
			var activeLeaseIndex = leases.findIndex(function (e) {
				return e.active === 1;
			});
			if (activeLeaseIndex > -1) {
				return leases[activeLeaseIndex];
			}
			return leases[0];
		},
		selectTab: function selectTab(selected) {
			this.tabs.forEach(function (tab) {
				tab.isActive = tab.name === selected.name;
			});

			Event.$emit('tab-type', selected.name);
			if (selected.event) {
				Event.$emit(selected.event);
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/ResidentTabs.vue
// module id = K1rA
// module chunks = 0 1